import { Typography } from '@mui/material';
import React from 'react';

import { getUserStatus } from '@entities/user/lib/helpers';

export const UserStatus = ({ isBlocked }: { isBlocked?: boolean }) => (
  <Typography color={isBlocked ? 'error.dark' : 'success.main'}>{getUserStatus(isBlocked)}</Typography>
);
